import Skeleton from "react-loading-skeleton"
import FloatTitleCard from "../cards/floatTitleCard"

const TurnDetailSkt = () => {
    return (
        <>
            <div className="pt-2 position-relative">

                <div className="timeVisitTurns background-bootstrap-gray-900 d-grid col-lg-1 col-3 text-center position-absolute tw-w-min">
                    <span className="fw-normal fs-14 color-bootstrap-gray-100 text-nowrap fit-content">
                        زمان نوبت
                    </span>
                </div>

                <div className="dateCardTime background-bootstrap-gray-100 border-radius-8  border-gray-300 d-grid col-lg-4 col-12 align-items-center mt-3 ">
                    <div className="tw-flex tw-gap-3 tw-w-full *:tw-flex-grow tw-max-w-3/4">
                        <Skeleton className="tw-p-2" />
                        <Skeleton className="tw-p-2" />
                    </div>
                </div>
            </div>

            <div className="pt-2 ">

                <div className="row">

                    <div className="col-lg-6 col-12">

                        <div className="col-12 color-bootstrap-gray-700">
                            <FloatTitleCard title={"اطلاعات پزشک"} error={false}>

                                <div className="tw-flex tw-gap-2 tw-items-center">
                                    <Skeleton className="tw-size-12 *:tw-size-full tw-rounded-full" />
                                    <div className="tw-flex tw-flex-col tw-justify-between tw-mt-2 *:tw-w-min">
                                        <Skeleton className="tw-w-16 tw-p-1" />
                                        <Skeleton className="tw-w-7" />
                                    </div>
                                </div>

                                <div className="d-flex flex-column mt-1 fs-14 color-bootstrap-gray-700">

                                    <span className="ps-2 my-1  fw-medium fs-14 color-bootstrap-gray-800">
                                        <Skeleton />
                                    </span>

                                    <span className="ps-2 my-1  fw-medium fs-14 color-bootstrap-gray-800">
                                        <Skeleton />
                                    </span>

                                    <span className="ps-2 my-1  fw-medium fs-14 color-bootstrap-gray-800">
                                        <Skeleton />
                                    </span>

                                </div>

                            </FloatTitleCard>
                        </div>

                        <div className="col-12 color-bootstrap-gray-700">
                            <FloatTitleCard title={"اطلاعات بیمار"} error={false}>

                                <div className="tw-flex tw-gap-2 tw-items-center">
                                    <Skeleton className="tw-size-12 *:tw-size-full tw-rounded-full" />
                                    <div className="tw-flex tw-flex-col tw-justify-between tw-mt-2 *:tw-w-min">
                                        <Skeleton className="tw-w-16 tw-p-1" />
                                        <Skeleton className="tw-w-7" />
                                    </div>
                                </div>

                                <div className="d-flex flex-column mt-1 fs-14 color-bootstrap-gray-700">

                                    <span className="ps-2 my-1  fw-medium fs-14 color-bootstrap-gray-800">
                                        <Skeleton />
                                    </span>

                                    <span className="ps-2 my-1  fw-medium fs-14 color-bootstrap-gray-800">
                                        <Skeleton />
                                    </span>

                                    <span className="ps-2 my-1  fw-medium fs-14 color-bootstrap-gray-800">
                                        <Skeleton />
                                    </span>

                                </div>

                            </FloatTitleCard>
                        </div>

                        <div className="col-12 color-bootstrap-gray-700">
                            <FloatTitleCard title={"صورت حساب"} error={false}>

                                <div className="d-flex justify-content-between mt-2">
                                    <Skeleton className="tw-w-14 tw-p-1" />
                                    <Skeleton className="tw-w-14 tw-p-1" />
                                </div>

                                <div className="d-flex justify-content-between mt-2">
                                    <Skeleton className="tw-w-14 tw-p-1" />
                                    <Skeleton className="tw-w-14 tw-p-1" />
                                </div>

                                <div className="d-flex flex-column border-bottom pb-2 gap-2">

                                </div>

                                <div className="d-flex justify-content-between mt-2">
                                    <Skeleton className="tw-w-14 tw-p-1" />
                                    <Skeleton className="tw-w-14 tw-p-1" />
                                </div>

                                <div className="factorTurn mt-2 border-radius-8 border-gray-200">
                                    <div className="d-flex justify-content-between tw-px-2 align-items-center">
                                        <div className="d-flex align-items-center gap-2">
                                            <Skeleton className="tw-w-12 tw-p-1" />
                                        </div>
                                        <Skeleton className="tw-w-12 tw-p-1" />
                                    </div>
                                </div>

                            </FloatTitleCard>
                        </div>

                    </div>

                    <div className="col-lg-6 col-12">
                        <div className="col-12 color-bootstrap-gray-700">
                            <FloatTitleCard title={"یادداشت‌ها"} error={false}>
                                <Skeleton className="tw-w-22 tw-h-12" />
                            </FloatTitleCard>
                        </div>
                    </div>

                </div>

            </div>

        </>
    )
}

export default TurnDetailSkt